module.exports = __webpack_public_path__ + "static/media/cargo.b2b6111d.png";